import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Button, Flag, Grid, Header } from "semantic-ui-react";

export default function HomePage() {
  const history = useHistory();
  useEffect(() => {
    //history.push(`/uzb`);
  }, []);
  return (
    <>
      <div className="country-choice-wrapper">
        <div className="country-choice">
          <Grid columns="equal" className="home-country country-grid1">
            <Header as="h2" className="home-header">
              Pilot
            </Header>
            <Grid.Row>
              <Grid.Column className="country-col1">
                <Button onClick={() => history.push(`/uzb`)}>
                  <Flag name="uzbekistan" /> Uzbekistan
                </Button>
              </Grid.Column>
              <Grid.Column className="country-col2">
                <Button onClick={() => history.push(`/kh`)}>
                  <Flag name="cambodia" /> Cambodia
                </Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <Grid columns="equal" className="home-country country-grid1">
            <Header as="h2" className="home-header">
              TIESEA
            </Header>
            <Grid.Row>
              <Grid.Column className="country-col1">
                <Button onClick={() => history.push(`/ph`)}>
                  <Flag name="ph" /> Philippines
                </Button>
              </Grid.Column>
              <Grid.Column className="country-col2">
                <Button onClick={() => history.push(`/vt`)}>
                  <Flag name="vn" /> Viet Nam
                </Button>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column className="country-col1">
                <Button onClick={() => history.push(`/ind`)}>
                  <Flag name="id" /> Indonesia
                </Button>
              </Grid.Column>
              <Grid.Column className="country-col2">
                <Button onClick={() => history.push(`/kh`)}>
                  <Flag name="cambodia" /> Cambodia
                </Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </div>
    </>
  );
}
